var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-col',[_c('p',{staticClass:"text-body-2 mb-0"},[_vm._v(" CUPP performs unsupervised clustering of proteins and fast annotation of enzymes including carbohydrate-active, proteases and sulfatases giving enzyme family, subfamily and EC function from conserved peptide patterns. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }